export interface CurrencyCodeObject {
  symbol: string;
  name?: string;
  currencyLocal: string;
  decimal_digits: number;
  rounding: number;
  code: string;
  name_plural?: string;
  money_format?: string;
  money_with_currency_format?: string;
  decimal?: string;
  thousand?: string;
  font?: string;
}
